import { createStore } from 'effector';
import { Cookies } from 'react-cookie';
import en from '../../assets/locale/en.json';
import ru from '../../assets/locale/ru.json';

const cookies = new Cookies();

const initLanguage = cookies.get('language') || 'ru';

export const $cities = createStore([]);
$cities.watch((state) => console.log('$cities', state));

export const $activeCity = createStore('');
$activeCity.watch((state) => console.log('$activeCity', state));

export const $hexagons = createStore([]);
$hexagons.watch((state) => console.log('$hexagons', state));

export const $startHexagons = createStore([]);

export const $showMetric = createStore(true);

export const $activeMetric = createStore('zoom9_population');

export const $showCharts = createStore(false);

export const $activeYear = createStore(2016);
$activeYear.watch((state) => console.log('$activeYear', state));

export const $loader = createStore(false);
$loader.watch((state) => console.log('$loader', state));

export const $floodsArea = createStore([]);
$floodsArea.watch((state) => console.log('$floodsArea', state));
export const $floodsStartArea = createStore([]);

export const $mudfloodsArea = createStore([]);
$mudfloodsArea.watch((state) => console.log('$mudfloodsArea', state));
export const $mudfloodsStartArea = createStore([]);

export const $metricDetails = createStore(null);

export const $language = createStore(initLanguage);

export const $chatMessages = createStore([
  {
    text: `
        ${initLanguage === 'ru' ? ru.welcome : en.welcome}<br/>
${initLanguage === 'ru' ? ru.assistant_text : en.assistant_text}
      `,
    fromUser: false,
  },
]);
$chatMessages.watch((state) => console.log('$chatMessages', state));

export const $isChatFilters = createStore(false);

export const $chatHexagons = createStore({});

export const $chatOpen = createStore(false);

export const $chartsStartData = createStore({});
export const $chartsData = createStore({});
$chartsData.watch((state) => console.log('$chartsData', state));
